<div class="row justify-content-center">
  <div *ngFor="let card of cards; let i = index" [class]="columns">
    <div class="info-box">
      <div class="icon-container">
        <img [src]="card.icon" [alt]="card.alt">
      </div>
      <div class="info-box-content">
        <span class="info-box-text">{{ card.text }}</span>
        <span class="info-box-number">{{ card.value }}</span>
      </div>
    </div>
  </div>
</div>
